<template>
<div v-if="this.$store.state.is_auth">
	<!-- если нет никаких ошибок -->
	<template v-if="!form_ErrorMessage">
		<!-- блок с локальным сообщением об ошибке -->
		<transition name="fadeControl" key="transitionError">
			<div v-show="localErrorMessage !== ''" class="alert alert-danger margin-20-0" role="alert">
				{{ localErrorMessage | ftc }}
				<button @click="localErrorMessage = ''" class="close" :title="'main/close' | ftc">×</button>
			</div>
		</transition>

		<!-- текст -->
		<div class="w5-block-bordered">
			<h4>{{ 'bonus/description_header' | ftc }}</h4>
			<br>
			<div><p v-withSafeTags="localeFtc('bonus/description_text')"></p></div>
		

			<!-- кнопка активации -->
			<button type="button" class="btn btn-submit-green font-weight-400 margin-15-0" @click="activateBonus">{{ 'main/activate' | ftc }}</button>
		</div>

		<!-- Bonus -->
		<div v-if="Bonus && Bonus['value'] && Array.isArray(Bonus['value']) && Bonus['value'].length" class="info-block with-flex">

			<div class="info-box for-bonus">
				<div class="info-box-content margin-0 bonus-item">
					<h4>{{ Bonus['title'] | ftc }}</h4>
					<ul class="info-box-list">
						<li v-for="(b, i) in Bonus['value']">
							<linkComponent :url="'/bonus/view/' + b['bonus_id']" :text="b['bonus_name']" :class="!b['active'] ? 'not-active-bonus' : ''" />
						</li>
					</ul>
				</div>
			</div>

		</div>
		

		<!-- диалог активации бонуса -->
		<transition name="modal">
			<div v-show="showBonusModal" @click="hideBonusModal" class="modal-mask">
				<div class="modal-wrapper">
					<div class="modal-container" @click.stop>

						<!-- заголовок -->
						<div class="modal-header">
							<span class="font-weight-500">{{ 'bonus/convert' | ftc }}</span>
							<button type="button" class="close" @click="hideBonusModal">&times;</button>
						</div>
					
						<!-- тело диалога -->
						<div class="modal-body">
							<div class="w5-form-row">
								<Field
									:isVisibleRow="true"
									crud="vds"
									action="view"
									v-model="bonusValue"
									:Field="bonusField"
									:fieldInModal="true"
									:removeRightPadding="true"
									@focus="onFocus"
									@enterKeyDown="activateBonusStart" />
							</div>
						</div>

						<!-- подвал -->
						<div class="modal-footer">
							<span class="btn btn-submit-green pull-right" @click="activateBonusStart">{{ 'main/activate' | ftc }}</span>
						</div>
					</div>
				</div>
			</div>
		</transition>


		<!-- блок с локальным сообщением об успехе -->			
		<transition name="fallingBlock" key="transitionSuccess">
			<div v-show="localSuccessMessage !== ''" class="alert alert-success font-size-90 falling-block" role="alert" style="margin-right: 10px; word-break: break-word;">
				<button @click="localSuccessMessage = ''" class="close" :title="'main/close' | ftc">×</button>
				{{ localSuccessMessage | ftc }}
			</div>
		</transition>


	</template>
</div>
</template>

<script>
///////////////////////////////////////////////////////////////////////////////
import Field from '@/components/elements/formfield'
import Helper from '@/helper/helper'
import { EventBus } from '@/bus.js'
///////////////////////////////////////////////////////////////////////////////
export default {
	//=========================================================================
	// наименование
	//=========================================================================
	name: 'Bonus',
	//=========================================================================
	// изменяемые локальные свойства
	//=========================================================================
	data() {
		return {
			// закешированные данные GET-запроса
			formData: false,

			// данные о бонусах
			curBonuses: null,

			// наименование CRUD-объекта
			crud: 'bonus',

			// локальное сообщение об ошибке
			localErrorMessage: '',
			// и об успехе
			localSuccessMessage: '',
			localSuccessMessageTimer: null,

			// диалог активации бонусов
			showBonusModal: false,
			bonusValue: '',
			bonusField: {
				'required': true,
				'type': 'text',
				'title': 'bonus/code',
				'_field_name': 'bonusCode',
				'_visible': true,
				'_errMsg': ''
			},

			// ID аккаунта
			accountId: false
		}
	},
	//=========================================================================
	//  вычисляемые неизменяемые переменные
	//=========================================================================
	computed: {
		// конфигурация
		Config() {
			if (this.$store.state.user_type === 'client') return this.$store.state.clientConfig
			else if (this.$store.state.user_type === 'admin') return this.$store.state.adminConfig
			else return false
		},
		// наименование модели CRUD
		model() {
			return this.Config[this.crud]['model'] ? this.Config[this.crud]['model'] : this.formater_capitalizeFirstChar(this.crud) + 'Search'
		},
		// тип пользователя
		UserType() {
			return this.$store.state.user_type
		},
		// Bonus
		Bonus() {
			if (this.curBonuses && this.curBonuses['value']) return this.curBonuses
			else return false
		}
	},
	//=========================================================================
	// функция, которыя будет вызвана после создания компонента,
	// но перед монтированием в дом
	//=========================================================================
	created() {
		// если не авторизован - редирект на страницу логина
		if (!this.$store.state.is_auth)
		{
			// сброс аутентификации
			this.$store.commit('dropAuth')
			// запоминаем URL, что бы к нему вернуться
			this.$store.commit('setReturnURL', this.$route.path)
			// остановим Push-систему
			this.$store.commit('pushStop')
			// делаем редирект
			return this.$router.push('/login')
		}

		// сразу запрашиваем данные формы и текущие бонусы
		this.currentBonuses()
		this.requestForm()
	},
	//=========================================================================
	// после того как компонент смонтирован
	//=========================================================================
	mounted() {
		// навешиваем обработчик на нажатие клавиш
		document.addEventListener('keydown', this.keyDownHandler)
	},
	//=========================================================================
	// перед уничтожением компонента
	//=========================================================================
	beforeDestroy() {
		document.removeEventListener('keydown', this.keyDownHandler)
	},
	//=========================================================================
	// метолы компонента
	//=========================================================================
	methods: {
		//---------------------------------------------------------------------
		// запрос текущих бонусов
		//---------------------------------------------------------------------
		currentBonuses() {
			// делаем запрос
			this.$http.get(this.APIServerUrl + '/bonus/index').then(
				res => {
					// получаем ответ
					let _dt = res && res.data && typeof res.data === 'object' ? res.data : false
					// если ответ корректный
					if (_dt && _dt['status'] === 'ok' && 'bonus' in _dt && _dt['bonus'] && _dt['bonus'])
					{
						this.curBonuses = _dt['bonus']
						return
					}

					// иная ошибка
					this.localErrorMessage = this.formatRequestError(res)
				},
				res => { this.localErrorMessage = this.formatRequestError(res) }
			)
		},
		//---------------------------------------------------------------------
		// запрос данных формы
		//---------------------------------------------------------------------
		requestForm() {
			// обнуляем аккаунт
			this.accountId = false
			// делаем запрос
			this.$http.get(this.APIServerUrl + '/bonus/convert').then(
				res => {
					// получаем ответ
					let _dt = res && res.data && typeof res.data === 'object' ? res.data : false
					// если ответ корректный
					if (_dt && _dt['status'] === 'form' && _dt['fields'] && _dt['fields']['account_id'] && _dt['fields']['account_id']['value'])
					{
						this.accountId = _dt['fields']['account_id']['value']
						return
					}

					// иная ошибка
					this.localErrorMessage = this.formatRequestError(res)
				},
				res => { this.localErrorMessage = this.formatRequestError(res) }
			)
		},
		//---------------------------------------------------------------------
		// активация бонуса
		//---------------------------------------------------------------------
		activateBonus() {
			// обнуляем значения
			this.localErrorMessage = ''
			this.localSuccessMessage = ''
			this.bonusValue = ''
			this.bonusField['_errMsg'] = ''
			// проверка аккаунта
			if (!this.accountId)
			{
				this.localErrorMessage = 'account/not_found'
				return
			}
			// запускаем диалог
			EventBus.$emit('w5-body-scroll-disable')
			this.showBonusModal = true
		},
		//---------------------------------------------------------------------
		// закрытие диалога
		//---------------------------------------------------------------------
		hideBonusModal() {
			EventBus.$emit('w5-body-scroll-enable')
			this.showBonusModal = false
			this.hideModalMask()
		},
		//---------------------------------------------------------------------
		// фокус на поле активации бонуса
		//---------------------------------------------------------------------
		onFocus() {
			this.bonusField['_errMsg'] = ''
		},
		//---------------------------------------------------------------------
		// старт активации кода
		//---------------------------------------------------------------------
		activateBonusStart() {
			// обнуляем сообщения об ошибке
			this.localErrorMessage = ''
			this.localSuccessMessage = ''

			// проверка аккаунта
			if (!this.accountId)
			{
				this.localErrorMessage = 'account/not_found'
				this.hideBonusModal()
				return
			}

			// проверка введенного значения
			if (!this.bonusValue || this.bonusValue === '')
			{
				this.bonusField['_errMsg'] = 'error/required_field'
				return
			}

			// все в порядке - формируем URL
			let _url = this.APIServerUrl + '/bonus/convert'
			// начинаем двойной запрос
			this.$http.get(_url).then(
				// положительный ответ
				resGet => {
					// получаем ответ
					let _dt = resGet && resGet.data && typeof resGet.data === 'object' ? resGet.data : false
					// если ответ корректный
					if (_dt && _dt['_csrf'] && _dt['model'] && _dt['status'] === 'form')
					{
						// готовим данные POST
						let _post = { '_csrf': _dt['_csrf'] }
						_post[_dt['model']] = {
							'account_id': this.accountId,
							'code': this.bonusValue
						}
						// производим запрос POST
						this.$http.post(_url, Helper.toFormData(_post)).then(
							// успешный ответ сервера
							resPost => {
								_dt = resPost && resPost.data && typeof resPost.data === 'object' ? resPost.data : false
								// если ошибки нет
								if (_dt && _dt['status'] === 'ok')
								{
									// сразу закрываем диалог
									this.hideBonusModal()
									// покадем сообщение об успехе
									this.setLocalSuccessMessage('bonus/converted')
									// обязательно запросим снова инфу о текущих бонусах
									this.currentBonuses()
									// на это все
									return
								}

								// иная ошибка
								this.bonusField['_errMsg'] = this.formatRequestError(resPost)

								// если указана какая то ошибка
								if (_dt && _dt['status'] === 'error')
								{
									// если что то передали для host
									if (_dt['fields'] && _dt['fields']['code'])
									{
										if (Array.isArray(_dt['fields']['code']))
										{
											if (_dt['fields']['code'].length)
												this.bonusField['_errMsg'] = this.localeFtc(_dt['fields']['code'][0])
										}
										else this.bonusField['_errMsg'] = this.localeFtc(_dt['fields']['code'])
									}
								}
							},
							// отрицательный ответ сервера
							resPost => {
								// сразу закрываем диалог
								this.hideBonusModal()
								this.localErrorMessage = this.formatRequestError(resPost)
							}
						)

						// на этом все
						return
					}

					// сразу закрываем диалог
					this.hideBonusModal()
					// ошибка формата ответа
					this.localErrorMessage = this.formatRequestError(resGet)
				},
				// отрицательный ответ
				resGet => {
					// сразу закрываем диалог
					this.hideBonusModal()
					this.localErrorMessage = this.formatRequestError(resGet)
				}
			)
		},
		//---------------------------------------------------------------------
		// событие: нажата клавиша
		//---------------------------------------------------------------------
		keyDownHandler(e) {
			if (e.keyCode === 27)
			{
				this.hideBonusModal()
			}
		},
		//---------------------------------------------------------------------
		// установка успешного сообщения
		//---------------------------------------------------------------------
		setLocalSuccessMessage(msg) {
			EventBus.$emit('w5-notificator-add', {
				'title': ' ',
				'message': msg,
				'class': 'success',
				'type': 'nourl',
				'id': 'success-message',
				'timeout': 3000
			})
		}

		//---------------------------------------------------------------------
	},
	//=========================================================================
	// используемые компоненты
	//=========================================================================
	components: {
		Field
	}

	//=========================================================================
}
///////////////////////////////////////////////////////////////////////////////
</script>

<style>
.info-box-list {
	margin-top: 0px;
	margin-bottom: 0;
	color: #2880da;
	font-weight: 500;
}
.w5-application.mc .info-box-list {
	color: #3250ba;
}
.info-box-list li {
	padding: 5px 0;
}
</style>



// WEBPACK FOOTER //
// Bonus.vue?f079d3c6